import { render, staticRenderFns } from "./OnlineTab.vue?vue&type=template&id=2f13f526&scoped=true&lang=pug&"
import script from "./OnlineTab.vue?vue&type=script&lang=js&"
export * from "./OnlineTab.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTab.vue?vue&type=style&index=0&id=2f13f526&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13f526",
  null
  
)

export default component.exports